export default "<h1>Type9Specials list</h1>\n<spec-app-type9-specials-table [clickHandler]=\"createClickHandler()\"></spec-app-type9-specials-table>";